module.exports = __webpack_public_path__ + "img/084ff7d.jpg";